import { Component, HostBinding, Input } from '@angular/core';
import { AppService } from '../../../app.service';
import { ApiService } from '../../../share/services/api.service';
import { SharedModule } from '../../../share/shared.module';
import { ConfigService } from '../../../share/services/config.service';

@Component({
  selector: 'app-layout-footer',
  templateUrl: './layout-footer.component.html',
  styleUrls: ['layout-footer.component.scss'],
  imports: [SharedModule]
})
export class LayoutFooterComponent {
  @Input() isLogin: boolean = false;
  @HostBinding('class.layout-footer') hostClassMain = true;
  portalVersion: any;
  isAcceptance = false;

  constructor(
    private appService: AppService,
    private api: ApiService,
    private configService: ConfigService
  ) {
    this.isAcceptance = configService.getEnv('fetrapiEnv') != 'PRO' ? true : false;

    this.api.getPortalVersion().subscribe({
      next: (data: any) => {  
        this.portalVersion = data.portalVersion;
      },
      error: (error) => {
        this.api.errorhandler(error);
      }
    })
  }

  currentBg() {
    return `bg-${this.appService.layoutFooterBg}`;
  }
}
